import GatewayContainer from '../config/GatewayContainer';
import GatewayNames from '../constant/GatewayNames';
import { AuditClient } from '../client/audit/AuditClient';
import { query } from '@trlogic/client-js';
import { AuditLog } from '../domain/rbac/RbacDomains';
import Query = query.Query;
import Filter = query.Filter;
import Order = query.Order;

class AuditService {
  private auditClient: AuditClient = GatewayContainer.getInstance().get(GatewayNames.AUDIT_CLIENT);

  public getCount = (query: Query) => {
    return this.auditClient.getCount(query);
  };

  public getKeycloakAdminEvents = (first: number, max: number, filter: Filter, sorts: Order[]) => {
    return this.auditClient.getKeycloakAdminEvents(first, max, filter, sorts);
  };
  public getKeycloakLoginEvents = (first: number, max: number, filter: Filter, sorts: Order[]) => {
    return this.auditClient.getKeycloakLoginEvents(first, max, filter, sorts);
  };

  public getKeycloakAdminEventsCount = (filter: Filter) => {
    return this.auditClient.countKeycloakAdminEvents(filter);
  };

  public getKeycloakLoginEventsCount = (filter: Filter) => {
    return this.auditClient.countKeycloakLoginEvents(filter);
  };

  public save = (log: AuditLog) => {
    return this.auditClient.save(log);
  };
}

export default AuditService;
